module.exports = __webpack_public_path__ + "img/5.b18b9e33.png";